
module.exports = (typeof WeakMap !== 'undefined') ? WeakMap : require("weak-map");



//////////////////
// WEBPACK FOOTER
// ./~/collections/weak-map.js
// module id = 91
// module chunks = 57